import { render, staticRenderFns } from "./DeclineModal.vue?vue&type=template&id=588127bb&scoped=true&"
import script from "./DeclineModal.vue?vue&type=script&lang=ts&"
export * from "./DeclineModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588127bb",
  null
  
)

export default component.exports